import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import { STATIC_IMAGES } from '../../../app.config.vars/staticImages';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
const NoInternetToSaveGameResult = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    return (_jsxs("div", { className: 'modal-content no-internet-to-save-game-result', children: [_jsx("div", { className: "modal-content-icon", children: _jsx("img", { src: localStorage.getItem(STATIC_IMAGES.noInternet.key) || undefined, alt: "no internet connection" }) }), _jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('return_to_save_game_result'), type: 'h1' }) }), _jsx("div", { className: "modal-content-button", children: _jsx(Button, { label: t('button.ok'), onClick: () => {
                        dispatch(setIsModalOpen(false));
                        dispatch(setModalContent(null));
                    } }) })] }));
};
export default NoInternetToSaveGameResult;
